export enum AffiliationEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  PUBLISHER = 'PUBLISHER',
}
